import { ComboBox } from "@progress/kendo-react-dropdowns";
import { useSelectedComponent } from "../../../../Hooks/Display/useComponents";
import { useComponentProperties, useFetchedValues } from "../../../../Hooks/Display/useComponentProperties";
import { useEffect, useState } from 'react';
import { byAttributeName } from "../../utils";

const ProgressProperty = () => {

    const selectedComponent = useSelectedComponent();

    const [properties, setProperty] = useComponentProperties();

    const [{ generalProperties: fetchedValues }] = useFetchedValues();

    const [progressAttributes, setProgressAttributes] = useState([]);

    useEffect(() => {
        if (fetchedValues.attributes && fetchedValues.attributes.length > 0) {
            const progressAttributes = fetchedValues.attributes
                .filter(attribute => !attribute.isSystemAttribute && attribute.attributeType === "Number")
                .sort(byAttributeName);
            setProgressAttributes(progressAttributes)
        }
    }, [fetchedValues.attributes])

    const handleProgressPropertyChange = (e) => {
        setProperty("progressAttribute", e.target.value ? e.target.value : { _id: "" });
    }

    return (
        <div className="clearBtn">
            <ComboBox
                className="w-100 select-overflow "
                disabled={selectedComponent.hidden}
                onChange={handleProgressPropertyChange}
                value={properties.progressAttribute}
                textField='attributeName'
                data={progressAttributes}
                dataItemKey='_id'
            />
        </div>
    )
}

export default ProgressProperty;